export default __webpack_public_path__ + "1a4167453d12c8eee50f9690cea8d026.glb";